// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2L6xR","assignButton":"CreateEditEquipmentSchedule_assignButton__2CxiW"};